export const searchApiURL = {
  users: "/search/users",
  allowedUsersForTask: "/search/allowed-users",
};
